const Data = [
    {
      id: 1,
      category: "education",
      icon: "icon-graduation",
      year: "2022 - present",
      title: "National Polytechnic Institute of Cambodia",
      major: "Computer Science",
      summary:"I am a third-year Computer Science student at the National Polytechnic Institute of Cambodia, currently pursuing a Bachelor's degree. My academic journey reflects my passion for technology and innovation, preparing me to excel in the dynamic field of Computer Science."

    },
    {
      id: 2,
      category: "education",
      icon: "icon-graduation",
      year: "2023 - 2024",
      title: "Beltei International School",
      major: "English Language Course",
      summary:"I have been studying English as a Second Language at Beltei International School,enhancing my proficiency and communication skills in English."

    },
    {
      id: 3,
      category: "education",
      icon: "icon-graduation",
      year: "2024 - 2024",
      title: "IT Academy STEP Cambodia",
      major: "Cyber Security",
      summary:"I have successfully completed a Cyber Security course at IT STEP Academy Cambodia and Cisco Networking Academy, enhancing my understanding of network security and protection against cyber threats."
    },
    {
      id: 4,
      category: "experience",
      icon: "icon-briefcase",
      year: "2019 - 2022",
      title: "Facebook Pages Management Services",
      desc: "Managed and optimised Facebook pages to ensure effectively administered and optimised Facebook business pages for clients, with a strong emphasis on boosting engagement and enhancing overall page performance."
    },
    {
      id: 5,
      category: "experience",
      icon: "icon-briefcase",
      year: "2022 - 2023",
      title: "Cashier Services",
      desc: "I do as a Cashier at Mart which operated the cash register, processed transactions, and handled customer payments with accuracy and efficiency. and Managed inventory by adding new stock, ensuring shelves were well-stocked and organized.",
    },
    {
      id: 6,
      category: "experience",
      icon: "icon-briefcase",
      year: "2024 - 2025",
      title: "Trainee-Back-End Developer",
      desc: "I have been training as a Backend Developer at Kilo IT, specializing in Java Spring Boot. Additionally, I have explored various aspects of the software development lifecycle, project management, and business analysis, enhancing my technical and strategic skills in the field.",
    },
    {
      id: 7,
      category: "education",
      icon: "icon-graduation",
      year: "2024 - 2025",
      title: "Korean Software HRD Centre",
      major: "ITE 13th Generation",
      summary:"Currently studying Full-Stack Development at KSHRD. In the Basic Course, I focused on Spring Boot and Next.js, and in the Advanced Course, I specialized in advanced Spring Boot"
    },
  ];
  
export default Data